// Tour data for Indotravelista

export const worldwideTours = [
  {
    id: 'nepal-spiritual-journey',
    title: '7D6N Nepal Spiritual & Scenic Journey',
    subtitle: 'Spiritual Journey • Scenic Landscapes • Timeless Heritage',
    destination: 'Kathmandu • Lumbini • Pokhara',
    duration: '7 Days / 6 Nights',
    dates: '5 – 11 December 2026',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4',
    category: 'worldwide',
    continent: 'asia',
    region: 'south-asia',
    country: 'nepal',
    destinations: ['nepal'],
    highlights: [
      'Everest Mountain Flight Experience',
      'Birthplace of Buddha - Lumbini Sacred Gardens',
      'Pokhara Lakeside & Annapurna Views',
      'Ancient Temples & Monasteries',
      'Scenic Himalayan Landscapes'
    ],
    itinerary: [
      {
        day: 1,
        date: '5 Dec',
        title: 'Arrival in Kathmandu',
        activities: 'Arrival in Kathmandu, private transfer to hotel (±15 mins), guide meet & briefing, rest & recover.'
      },
      {
        day: 2,
        date: '6 Dec',
        title: 'Kathmandu Valley & Everest Flight',
        activities: 'Early morning Everest Mountain Flight (±1 hr), Swayambhunath (Monkey Temple), Boudhanath Stupa, relaxed Kathmandu Valley sightseeing.'
      },
      {
        day: 3,
        date: '7 Dec',
        title: 'Kathmandu to Lumbini',
        activities: 'Flight Kathmandu to Bhairahawa (±40–45 mins), explore Lumbini (Birthplace of Buddha, Mayadevi Temple, sacred gardens, Peace Pagoda).'
      },
      {
        day: 4,
        date: '8 Dec',
        title: 'Lumbini to Pokhara',
        activities: 'Scenic drive from Lumbini to Pokhara through hills and landscapes, check-in hotel in Lakeside Pokhara.'
      },
      {
        day: 5,
        date: '9 Dec',
        title: 'Pokhara Sightseeing',
        activities: 'Pokhara sightseeing: World Peace Pagoda, Matepani Gumba Monastery, Phewa Lake & Annapurna range views.'
      },
      {
        day: 6,
        date: '10 Dec',
        title: 'Return to Kathmandu',
        activities: 'Scenic drive Pokhara to Kathmandu, free evening for personal activities.'
      },
      {
        day: 7,
        date: '11 Dec',
        title: 'Departure',
        activities: 'Free time until airport transfer for departure.'
      }
    ],
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Nepal%20Tour%20(5-11%20Dec%202026).'
  },
  {
    id: 'bhutan-festival-journey',
    title: '7-Day Bhutan Druk Wangyel Festival & Himalayan Cultural Journey',
    subtitle: 'Festival. Culture. Himalayas. An Experience Like No Other.',
    destination: 'Paro • Thimphu • Punakha • Phobjikha',
    duration: '7-Day Cultural Journey',
    dates: '11 – 17 December',
    image: 'https://images.unsplash.com/photo-1598869012638-f5351b49498f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxCaHV0YW4lMjBQYXJvJTIwVGFrdHNhbmclMjBtb25hc3Rlcnl8ZW58MHx8fHwxNzg4MzAyMzU2fDA&ixlib=rb-4.1.0&q=85',
    category: 'worldwide',
    continent: 'asia',
    region: 'south-asia',
    country: 'bhutan',
    destinations: ['bhutan'],
    flight: 'Drukair KB401 (Kathmandu KTM 09:00 → Paro PBH 10:20, 1h 20m, Economy Class)',
    highlights: [
      'Druk Wangyel Festival at Dochula Pass',
      'Iconic Tiger\'s Nest Monastery Hike',
      '108 Chortens & Himalayan Panoramas',
      'Punakha Dzong & Suspension Bridge',
      'Phobjikha Valley & Black-Necked Cranes',
      'Traditional Farmhouse Dinner'
    ],
    itinerary: [
      {
        day: 1,
        date: '11 Dec',
        title: 'Paro to Thimphu',
        activities: 'Arrival via Drukair KB401, Tachog Viewpoint, Memorial Chorten, transfer to Thimphu.'
      },
      {
        day: 2,
        date: '12 Dec',
        title: 'Thimphu Exploration',
        activities: 'Buddha Dordenma, Traditional Arts Institute, Tashichho Dzong, Festival Briefing.'
      },
      {
        day: 3,
        date: '13 Dec',
        title: 'Druk Wangyel Festival',
        activities: 'Thimphu – Dochula – Punakha. Druk Wangyel Festival at Dochula Pass, 108 Chortens, Himalayan views.'
      },
      {
        day: 4,
        date: '14 Dec',
        title: 'Punakha to Phobjikha',
        activities: 'Punakha Dzong, Suspension Bridge, scenic drive to Phobjikha Valley.'
      },
      {
        day: 5,
        date: '15 Dec',
        title: 'Phobjikha to Paro',
        activities: 'Gangtey Monastery, Valley Walk, Crane Information Center, transfer to Paro.'
      },
      {
        day: 6,
        date: '16 Dec',
        title: 'Tiger\'s Nest Hike',
        activities: 'Iconic Tiger\'s Nest Hike / Paro Taktsang, Kyichu Lhakhang, Farmhouse Dinner.'
      },
      {
        day: 7,
        date: '17 Dec',
        title: 'Departure',
        activities: 'Paro Departure via Drukair to Kathmandu, Bangkok, or Delhi.'
      }
    ],
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Bhutan%20Festival%20Tour%20(11-17%20Dec).'
  },
  {
    id: 'shanghai-cruise',
    title: 'Ied Mubarrak Holiday: Shanghai + Royal Caribbean Cruise',
    subtitle: 'Spectrum of the Seas - China, Korea & Japan',
    destination: 'Shanghai • Jeju • Fukuoka',
    duration: '6D5N Cruise & City Extension',
    dates: '7 – 12 March 2027',
    image: 'https://images.unsplash.com/photo-1555881677-2d9b1b6a8118',
    category: 'worldwide',
    continent: 'asia',
    region: 'east-asia',
    country: 'china',
    destinations: ['china', 'south-korea', 'japan'],
    ship: 'Spectrum of the Seas by Royal Caribbean',
    highlights: [
      'Luxury Cruise Experience aboard Spectrum of the Seas',
      'Jeju Island (Seogwipo) - South Korea',
      'Fukuoka Cultural Experience - Japan',
      'Shanghai City Extension',
      'World-Class Dining & Entertainment',
      'Sea Days with Premium Amenities'
    ],
    itinerary: [
      {
        day: 1,
        date: '07 Mar 2027 (Sun)',
        title: 'Shanghai Boarding',
        activities: 'Shanghai (Baoshan), China – Boarding 4:00 PM. Welcome aboard, cabin check-in, safety drill, sail-away party.'
      },
      {
        day: 2,
        date: '08 Mar 2027 (Mon)',
        title: 'Cruising at Sea',
        activities: 'Enjoy onboard entertainment, fine dining, pools, spa, shows, and premium amenities.'
      },
      {
        day: 3,
        date: '09 Mar 2027 (Tue)',
        title: 'Jeju (Seogwipo), South Korea',
        activities: 'Docked 7:00 AM – 5:00 PM. Shore excursions to volcanic landscapes, beaches, and local markets.'
      },
      {
        day: 4,
        date: '10 Mar 2027 (Wed)',
        title: 'Fukuoka, Japan',
        activities: 'Docked 7:00 AM – 6:45 PM. Explore temples, gardens, shopping districts, and authentic Japanese cuisine.'
      },
      {
        day: 5,
        date: '11 Mar 2027 (Thu)',
        title: 'Cruising at Sea',
        activities: 'Final day at sea. Relax, enjoy shows, spa treatments, farewell dinner.'
      },
      {
        day: 6,
        date: '12 Mar 2027 (Fri)',
        title: 'Shanghai Arrival & Extension',
        activities: 'Shanghai (Baoshan) – Arrival 6:30 AM. Disembarkation & optional Shanghai city extension (Iconic Skyline, Historic Streets, Shopping & Culinary).'
      }
    ],
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Shanghai%20Royal%20Caribbean%20Cruise%20(7-12%20March%202027).'
  }
];

// Special Indonesia Experience (Not part of geographic hierarchy)
export const coffeeCivilization = {
  id: 'coffee-civilization',
  title: 'Indonesia Coffee Civilization & Heritage Expedition',
  subtitle: 'From Volcanic Terroirs to Cupping Masterclasses',
  destination: 'Bali • Java • Flores',
  duration: '10 Days / 9 Nights',
  dates: 'Year-Round Departures',
  image: 'https://images.unsplash.com/photo-1670758611084-e216510c5433',
  category: 'indonesia',
  type: 'special-experience',
  geographicGroups: ['bali-nusa-tenggara', 'java'],
  administrativeRegions: ['Bali', 'West Java', 'East Nusa Tenggara'],
  highlights: [
    'Single-Origin Plantation Farm Tours',
    'Professional Coffee Cupping Sessions',
    'Meet Award-Winning Roasters & Farmers',
    'Volcanic Terroir Exploration',
    'Farm-to-Cup Journey Experience',
    'Specialty Café Collaborations'
  ],
  itinerary: [
    {
      day: 1,
      title: 'Arrival in Bali',
      activities: 'Airport transfer, hotel check-in, welcome dinner with coffee tasting introduction.'
    },
    {
      day: 2,
      title: 'Kintamani Coffee Plantations',
      activities: 'Visit traditional Bali coffee farms, witness harvesting and processing, Luwak coffee experience.'
    },
    {
      day: 3,
      title: 'Specialty Coffee Roastery Tour',
      activities: 'Meet Bali specialty roasters, cupping session, learn roasting techniques.'
    },
    {
      day: 4,
      title: 'Flight to Java - Bandung',
      activities: 'Transfer to Java, explore Bandung coffee scene, visit historic colonial coffee estates.'
    },
    {
      day: 5,
      title: 'Java Coffee Heritage Trail',
      activities: 'Visit arabica plantations in highland regions, coffee processing mills, local farmer interactions.'
    },
    {
      day: 6,
      title: 'Professional Cupping Workshop',
      activities: 'Full-day intensive cupping masterclass with professional Q-grader, sensory evaluation training.'
    },
    {
      day: 7,
      title: 'Flight to Flores - Bajawa',
      activities: 'Transfer to Flores Island, discover Bajawa coffee region, volcanic soil terroir.'
    },
    {
      day: 8,
      title: 'Flores Coffee Villages',
      activities: 'Traditional coffee culture immersion, village homestay experience, handpicked coffee harvest.'
    },
    {
      day: 9,
      title: 'Flores to Bali Return',
      activities: 'Morning coffee ceremony, flight back to Bali, farewell dinner.'
    },
    {
      day: 10,
      title: 'Departure',
      activities: 'Free time for shopping coffee beans, airport transfer.'
    }
  ],
  whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Indonesia%20Coffee%20Civilization%20Expedition.'
};

export const indonesiaTours = [
  {
    id: 'bali-luxury-retreat',
    title: 'Signature Bali Luxury & Cultural Retreat',
    subtitle: 'Temples, Traditions & Premium Experiences',
    destination: 'Uluwatu • Ubud • Kintamani',
    duration: '4 Days / 3 Nights',
    dates: 'Daily Departures Available',
    image: '/YogaBali.jpg',
    category: 'indonesia',
    geographicGroup: 'bali-nusa-tenggara',
    administrativeRegion: 'Bali',
    cityOrArea: 'Ubud',
    highlights: [
      'Uluwatu Sunset Temple & Kecak Dance',
      'Kintamani Highland Coffee Plantation',
      'Penglipuran Traditional Village',
      'Private Luxury Transportation',
      'MICE Facility Coordination',
      'Exclusive Cultural Experiences'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival & South Bali',
        activities: 'Airport VIP meet & greet, luxury hotel check-in, Uluwatu Temple sunset visit, Kecak & Fire Dance performance.'
      },
      {
        day: 2,
        title: 'Ubud Cultural Immersion',
        activities: 'Tegallalang Rice Terrace, Ubud Art Market, Royal Palace, traditional dance performance, luxury spa treatment.'
      },
      {
        day: 3,
        title: 'Kintamani & Villages',
        activities: 'Kintamani Highland volcano views, premium coffee plantation tour with cupping, Penglipuran traditional village, handicraft shopping.'
      },
      {
        day: 4,
        title: 'Departure',
        activities: 'Morning leisure at resort, hotel check-out, private airport transfer.'
      }
    ],
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Bali%20Luxury%20%26%20Cultural%20Retreat%20(4D3N).'
  },
  {
    id: 'komodo-liveaboard',
    title: 'Komodo & Flores Liveaboard Odyssey',
    subtitle: 'Luxury Phinisi Sailing • Dragons • Manta Rays',
    destination: 'Komodo • Padar • Pink Beach • Flores',
    duration: '5 Days / 4 Nights',
    dates: 'Weekly Departures',
    image: '/SailingKomodo.jpg',
    category: 'indonesia',
    geographicGroup: 'bali-nusa-tenggara',
    administrativeRegion: 'East Nusa Tenggara',
    cityOrArea: 'Labuan Bajo',
    highlights: [
      'Komodo Dragon Encounters',
      'Padar Island Iconic Trekking',
      'Pink Beach Snorkeling',
      'Manta Ray Expeditions',
      'Luxury Phinisi Traditional Boat',
      'Private Island Beaches'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Labuan Bajo Departure',
        activities: 'Board luxury phinisi boat, sail to Kelor Island for snorkeling, sunset at Kalong Island (flying foxes).'
      },
      {
        day: 2,
        title: 'Padar & Pink Beach',
        activities: 'Early morning Padar Island trek for iconic views, Pink Beach snorkeling with coral gardens, Long Beach exploration.'
      },
      {
        day: 3,
        title: 'Komodo Island',
        activities: 'Komodo National Park ranger-guided dragon tracking, Manta Point diving/snorkeling with manta rays.'
      },
      {
        day: 4,
        title: 'Flores Islands Hopping',
        activities: 'Explore hidden bays, pristine beaches, snorkeling spots, sunset sailing.'
      },
      {
        day: 5,
        title: 'Return to Labuan Bajo',
        activities: 'Morning swimming, disembarkation, optional flight or ferry arrangements.'
      }
    ],
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Komodo%20%26%20Flores%20Liveaboard%20Odyssey.'
  },
  {
    id: 'sumatra-volcanoes-heritage',
    title: 'Sumatra: Volcanoes, Lakes & Sumatran Heritage',
    subtitle: 'Lake Toba • Highlands • Heritage • Coffee',
    destination: 'Medan • Lake Toba • Berastagi • Samosir',
    duration: '6 Days / 5 Nights',
    dates: 'Year-Round Departures',
    image: '/KalderaToba.jpg',
    category: 'indonesia',
    geographicGroup: 'sumatra',
    administrativeRegion: 'North Sumatra',
    cityOrArea: 'Lake Toba',
    highlights: [
      'Lake Toba - World\'s Largest Volcanic Caldera',
      'Samosir Island Traditional Batak Culture',
      'Berastagi Highlands & Fruit Markets',
      'Sipiso-Piso Waterfall',
      'Arabica Coffee Plantation Tours',
      'Traditional Batak Architecture & Villages'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Medan',
        activities: 'Airport transfer, Maimun Palace, Great Mosque of Medan, traditional culinary exploration.'
      },
      {
        day: 2,
        title: 'Medan to Berastagi',
        activities: 'Drive to Berastagi highlands, fruit market visit, Gundaling Hill viewpoint, traditional village exploration.'
      },
      {
        day: 3,
        title: 'Berastagi to Lake Toba',
        activities: 'Sipiso-Piso waterfall, scenic drive to Lake Toba, ferry to Samosir Island, hotel check-in.'
      },
      {
        day: 4,
        title: 'Samosir Island Exploration',
        activities: 'Traditional Batak villages, stone chairs, ancient tombs, Tuk Tuk village, cultural performances.'
      },
      {
        day: 5,
        title: 'Lake Toba & Coffee Plantations',
        activities: 'Arabica coffee plantation tour, lake activities, hot springs, sunset views over the caldera.'
      },
      {
        day: 6,
        title: 'Return to Medan & Departure',
        activities: 'Ferry back to Parapat, scenic drive to Medan, shopping time, airport transfer.'
      }
    ],
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Sumatra%20Volcanoes%20%26%20Heritage%20Tour.'
  },
  {
    id: 'java-ring-of-fire',
    title: 'Java: The Ring of Fire & Cultural Heritage',
    subtitle: 'Volcanoes • Temples • Culture • Landscapes',
    destination: 'Yogyakarta • Bromo • Ijen • Malang',
    duration: '7 Days / 6 Nights',
    geographicGroup: 'java',
    administrativeRegion: 'East Java',
    cityOrArea: 'Bromo',
    dates: 'Year-Round Departures',
    image: 'https://images.unsplash.com/photo-1518043610038-064362b44076',
    category: 'indonesia',
    highlights: [
      'Mount Bromo Sunrise Experience',
      'Ijen Blue Fire Crater Trek',
      'Borobudur Temple at Dawn',
      'Prambanan Hindu Temples',
      'Traditional Javanese Villages',
      'Volcanic Landscape Photography'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Yogyakarta',
        activities: 'Airport transfer, hotel check-in, Malioboro Street exploration, traditional dinner.'
      },
      {
        day: 2,
        title: 'Borobudur & Prambanan',
        activities: 'Sunrise at Borobudur Temple, Prambanan Temple complex, Ramayana sunset performance.'
      },
      {
        day: 3,
        title: 'Yogyakarta to Bromo',
        activities: 'Scenic drive through Java countryside, arrive at Mount Bromo area, evening briefing.'
      },
      {
        day: 4,
        title: 'Mount Bromo Sunrise',
        activities: 'Pre-dawn jeep ride, Bromo sunrise viewpoint, crater rim exploration, drive to Malang.'
      },
      {
        day: 5,
        title: 'Malang to Ijen',
        activities: 'Drive to Ijen base, prepare for blue fire trek, rest and early dinner.'
      },
      {
        day: 6,
        title: 'Ijen Blue Fire Trek',
        activities: 'Midnight trek to Ijen crater, blue fire phenomenon, sunrise over turquoise crater lake, coffee plantation visit.'
      },
      {
        day: 7,
        title: 'Departure',
        activities: 'Transfer to Surabaya or Bali, airport/ferry arrangements.'
      }
    ],
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Java%20Ring%20of%20Fire%20Tour.'
  },
  {
    id: 'yogyakarta-heritage',
    title: 'Yogyakarta: Java\'s Living Heritage',
    subtitle: 'Borobudur • Prambanan • Royal Heritage • Arts',
    destination: 'Yogyakarta • Magelang • Sleman',
    duration: '4 Days / 3 Nights',
    geographicGroup: 'java',
    administrativeRegion: 'Yogyakarta Special Region',
    cityOrArea: 'Yogyakarta',
    dates: 'Year-Round Departures',
    image: '/Stupa.jpg',
    category: 'indonesia',
    highlights: [
      'Borobudur Temple Sunrise Experience',
      'Prambanan Hindu Temple Complex',
      'Kraton Sultan Palace & Museums',
      'Traditional Batik & Silver Workshops',
      'Ramayana Ballet Performance',
      'Cave Temple & Waterfall Exploration'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival & City Orientation',
        activities: 'Airport transfer, hotel check-in, Malioboro Street shopping, Tugu Monument, street food exploration.'
      },
      {
        day: 2,
        title: 'Borobudur Sunrise & Temples',
        activities: 'Pre-dawn departure for Borobudur sunrise, Mendut & Pawon temples, traditional village lunch, afternoon Prambanan Temple with sunset.'
      },
      {
        day: 3,
        title: 'Royal Heritage & Crafts',
        activities: 'Kraton Sultan Palace, Water Castle (Taman Sari), batik-making workshop, silversmith village, evening Ramayana Ballet.'
      },
      {
        day: 4,
        title: 'Cave Temples & Departure',
        activities: 'Jomblang Cave adventure or Kaliurang highlands, shopping for souvenirs, airport transfer.'
      }
    ],
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Yogyakarta%20Heritage%20Tour.'
  },
  {
    id: 'banyuwangi-ijen',
    title: 'Banyuwangi: Ijen Blue Fire & Java\'s Wild East',
    geographicGroup: 'java',
    administrativeRegion: 'East Java',
    cityOrArea: 'Banyuwangi',
    subtitle: 'Ijen • Blue Fire • Coffee • Wilderness',
    destination: 'Banyuwangi • Ijen • Alas Purwo',
    duration: '4 Days / 3 Nights',
    dates: 'Year-Round Departures',
    image: '/Catimor.jpg',
    category: 'indonesia',
    highlights: [
      'Ijen Crater Blue Fire Phenomenon',
      'Turquoise Crater Lake Sunrise',
      'Sulfur Miners Cultural Experience',
      'Red Island Beach & Surfing',
      'Arabica Coffee Plantation Tour',
      'Traditional Osing Village Culture'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Banyuwangi',
        activities: 'Airport/ferry transfer, hotel check-in, Red Island beach sunset, local seafood dinner.'
      },
      {
        day: 2,
        title: 'Ijen Blue Fire Trek',
        activities: 'Midnight departure (1 AM), Ijen crater trek, blue fire viewing, sunrise over turquoise lake, return for rest.'
      },
      {
        day: 3,
        title: 'Coffee & Culture',
        activities: 'Arabica coffee plantation visit, traditional Osing village exploration, Bangsring underwater snorkeling.'
      },
      {
        day: 4,
        title: 'Departure',
        activities: 'Morning leisure, shopping for coffee beans, transfer to ferry terminal or airport.'
      }
    ],
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Banyuwangi%20Ijen%20Tour.'
  },
  {
    id: 'bali-beyond-beach',
    title: 'Bali Beyond the Beach',
    subtitle: 'Villages • Rice Terraces • Temples • Gastronomy',
    destination: 'Ubud • Sidemen • Munduk • Jatiluwih',
    duration: '5 Days / 4 Nights',
    dates: 'Year-Round Departures',
    image: 'https://images.unsplash.com/photo-1559628233-eb1b1a45564b',
    category: 'indonesia',
    geographicGroup: 'bali-nusa-tenggara',
    administrativeRegion: 'Bali',
    cityOrArea: 'Ubud',
    highlights: [
      'UNESCO Rice Terraces of Jatiluwih',
      'Traditional Village Homestays',
      'Balinese Cooking Classes',
      'Hidden Waterfalls & Temples',
      'Mount Batur Sunrise Trek',
      'Organic Farm-to-Table Experiences'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival & Ubud Immersion',
        activities: 'Airport transfer to Ubud, hotel check-in, Tegallalang rice terraces, Sacred Monkey Forest, art market.'
      },
      {
        day: 2,
        title: 'Sidemen Valley Exploration',
        activities: 'Drive to Sidemen Valley, traditional weaving village, rice paddy walks, waterfall visit, traditional homestay experience.'
      },
      {
        day: 3,
        title: 'Mount Batur Sunrise Trek',
        activities: 'Pre-dawn Mount Batur trek, sunrise breakfast on summit, hot springs relaxation, coffee plantation visit.'
      },
      {
        day: 4,
        title: 'Jatiluwih & Munduk',
        activities: 'UNESCO Jatiluwih rice terraces, Ulun Danu temple, Munduk waterfalls, mountain village dinner.'
      },
      {
        day: 5,
        title: 'Cooking Class & Departure',
        activities: 'Traditional Balinese cooking class, market visit, prepare and enjoy lunch, airport transfer.'
      }
    ],
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Bali%20Beyond%20the%20Beach%20Tour.'
  },
  {
    id: 'raja-ampat-paradise',
    title: 'Raja Ampat: The Last Paradise',
    subtitle: 'Marine Life • Islands • Diving • Remote Luxury',
    destination: 'Waisai • Wayag • Pianemo • Misool',
    duration: '7 Days / 6 Nights',
    dates: 'Year-Round Departures',
    image: '/RajaAmpat.jpg',
    category: 'indonesia',
    geographicGroup: 'papua',
    administrativeRegion: 'West Papua',
    cityOrArea: 'Raja Ampat',
    highlights: [
      'World\'s Richest Marine Biodiversity',
      'Wayag Islands Iconic Viewpoint',
      'Pianemo Karst Lagoons',
      'Manta & Whale Shark Encounters',
      'Private Island Hopping',
      'Luxury Liveaboard Experience'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Sorong & Transfer',
        activities: 'Flight to Sorong, transfer to Raja Ampat, hotel check-in or liveaboard boarding.'
      },
      {
        day: 2,
        title: 'Pianemo & Hidden Lagoons',
        activities: 'Pianemo viewpoint trek, kayaking through karst islands, snorkeling in pristine coral reefs.'
      },
      {
        day: 3,
        title: 'Wayag Islands',
        activities: 'Iconic Wayag viewpoint climb, panoramic photography, lagoon swimming, beach relaxation.'
      },
      {
        day: 4,
        title: 'Manta Point & Arborek',
        activities: 'Manta ray snorkeling/diving, Arborek village cultural visit, traditional dance performance.'
      },
      {
        day: 5,
        title: 'Misool Marine Reserve',
        activities: 'Explore Misool marine protected area, hidden lagoons, diverse diving spots, jellyfish lake.'
      },
      {
        day: 6,
        title: 'Island Hopping & Relaxation',
        activities: 'Private beach visits, snorkeling untouched reefs, sunset sailing, stargazing.'
      },
      {
        day: 7,
        title: 'Return & Departure',
        activities: 'Morning swim, transfer back to Sorong, flight arrangements.'
      }
    ],
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Raja%20Ampat%20Paradise%20Tour.'
  },
  {
    id: 'sumba-ancient-traditions',
    title: 'Sumba: Island of Ancient Traditions',
    subtitle: 'Megalithic Culture • Villages • Beaches • Traditions',
    destination: 'Waingapu • Waikabubak • Weekuri • Mandorak',
    duration: '6 Days / 5 Nights',
    dates: 'Year-Round Departures',
    image: '/Sumba.jpg',
    category: 'indonesia',
    highlights: [
      'Traditional Megalithic Tombs & Villages',
      'Authentic Ikat Weaving Communities',
      'Pasola Traditional Horse Ceremony',
      'Pristine White Sand Beaches',
      'Ancient Stone Grave Sites',
      'Weekuri Lagoon Natural Pool'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Waingapu',
        activities: 'Airport transfer, hotel check-in, Waingapu market visit, traditional village orientation.'
      },
      {
        day: 2,
        title: 'Traditional Villages',
        activities: 'Visit Praijing and Rende villages, megalithic tombs, traditional houses, ikat weaving demonstrations.'
      },
      {
        day: 3,
        title: 'Waingapu to Waikabubak',
        activities: 'Scenic cross-island drive, traditional villages en route, Waikabubak town exploration.'
      },
      {
        day: 4,
        title: 'Waikabubak & Hill Villages',
        activities: 'Tarung village traditional houses, panoramic hilltop views, megalithic stone sites, cultural ceremonies.'
      },
      {
        day: 5,
        title: 'Beaches & Weekuri Lagoon',
        activities: 'Mandorak Beach, Weekuri natural lagoon, snorkeling, beach relaxation, sunset views.'
      },
      {
        day: 6,
        title: 'Departure',
        activities: 'Morning leisure, shopping for traditional textiles, transfer to Tambolaka Airport.'
      }
    ],
    geographicGroup: 'bali-nusa-tenggara',
    administrativeRegion: 'East Nusa Tenggara',
    cityOrArea: 'Sumba',
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Sumba%20Ancient%20Traditions%20Tour.'
  },
  {
    id: 'borneo-rainforest',
    title: 'Borneo: Rainforest & Orangutan Expedition',
    subtitle: 'Rainforest • Wildlife • Rivers • Conservation',
    destination: 'Tanjung Puting • Kalimantan • Camp Leakey',
    duration: '5 Days / 4 Nights',
    dates: 'Year-Round Departures',
    image: '/Kalimantan.jpg',
    category: 'indonesia',
    highlights: [
      'Wild Orangutan Encounters',
      'Tanjung Puting National Park',
      'Klotok Riverboat Journey',
      'Camp Leakey Research Center',
      'Proboscis Monkey Sightings',
      'Rainforest Conservation Experience'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival & River Journey Begins',
        activities: 'Flight to Pangkalan Bun, transfer to port, board traditional klotok boat, begin river journey.'
      },
      {
        day: 2,
        title: 'Tanjung Harapan',
        activities: 'Trek to Tanjung Harapan feeding station, wild orangutan viewing, proboscis monkeys, river wildlife.'
      },
      {
        day: 3,
        title: 'Camp Leakey Research Center',
        activities: 'Visit Camp Leakey, meet research team, orangutan rehabilitation program, rainforest trekking.'
      },
      {
        day: 4,
        title: 'Pondok Tanggui & Wildlife',
        activities: 'Pondok Tanggui feeding platform, jungle trekking, hornbill and macaque sightings, night wildlife cruise.'
      },
      {
        day: 5,
        title: 'Return & Departure',
        activities: 'Morning wildlife viewing, river journey back to Pangkalan Bun, airport transfer.'
      }
    ],
    geographicGroup: 'kalimantan',
    administrativeRegion: 'Central Kalimantan',
    cityOrArea: 'Tanjung Puting',
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Borneo%20Rainforest%20Expedition.'
  },
  {
    id: 'sulawesi-highlands',
    title: 'Sulawesi: Culture, Highlands & Marine Life',
    subtitle: 'Toraja • Highlands • Heritage • Islands',
    destination: 'Makassar • Toraja • Bunaken • Manado',
    duration: '8 Days / 7 Nights',
    dates: 'Year-Round Departures',
    image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_7012c185-728e-48dd-a634-a866967c4d91/artifacts/0ahof2es_IMG_20200914_162746.webp',
    category: 'indonesia',
    highlights: [
      'Tana Toraja Funeral Ceremonies',
      'Traditional Tongkonan Houses',
      'Highland Coffee Plantations',
      'Bunaken Marine Park Diving',
      'Unique Burial Cliff Sites',
      'Minahasa Highland Villages'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Makassar',
        activities: 'Airport transfer, Fort Rotterdam, Losari Beach, traditional Makassar seafood dinner.'
      },
      {
        day: 2,
        title: 'Makassar to Toraja',
        activities: 'Scenic highland drive to Tana Toraja, traditional villages en route, hotel check-in.'
      },
      {
        day: 3,
        title: 'Toraja Cultural Immersion',
        activities: 'Tongkonan traditional houses, burial cliff sites (Londa, Lemo), baby tree grave, cultural ceremonies.'
      },
      {
        day: 4,
        title: 'Highland Villages & Coffee',
        activities: 'Highland village trekking, coffee plantation tours, traditional markets, weaving demonstrations.'
      },
      {
        day: 5,
        title: 'Toraja to Manado',
        activities: 'Flight to Manado, hotel check-in, city orientation, seafood dinner.'
      },
      {
        day: 6,
        title: 'Bunaken Marine Park',
        activities: 'Full-day Bunaken Island snorkeling/diving, pristine coral walls, marine biodiversity.'
      },
      {
        day: 7,
        title: 'Minahasa Highlands',
        activities: 'Tomohon flower market, active volcanoes, Linow Lake, traditional Minahasa village, highland cuisine.'
      },
      {
        day: 8,
        title: 'Departure',
        activities: 'Morning leisure, shopping, airport transfer.'
      }
    ],
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Sulawesi%20Highlands%20Tour.'
  },
  {
    id: 'maluku-spice-islands',
    title: 'Maluku: Spice Islands & Hidden Shores',
    subtitle: 'Spice Heritage • Islands • History • Marine Life',
    destination: 'Ambon • Banda Islands • Ternate • Tidore',
    duration: '7 Days / 6 Nights',
    geographicGroup: 'maluku',
    administrativeRegion: 'Maluku',
    cityOrArea: 'Banda Islands',
    dates: 'Year-Round Departures',
    image: '/Malut.jpg',
    category: 'indonesia',
    highlights: [
      'Historic Banda Islands Spice Trade',
      'Nutmeg & Clove Plantations',
      'Colonial Fort Belgica',
      'Pristine Coral Reefs & Diving',
      'Run Island Historic Sites',
      'Traditional Spice Processing'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Ambon',
        activities: 'Airport transfer, World War II sites, Siwalima Museum, Natsepa Beach.'
      },
      {
        day: 2,
        title: 'Ambon to Banda Islands',
        activities: 'Flight/ferry to Banda Neira, Fort Belgica, Dutch colonial architecture, spice market.'
      },
      {
        day: 3,
        title: 'Banda Islands Exploration',
        activities: 'Nutmeg plantation tours, Run Island historic VOC sites, snorkeling pristine reefs.'
      },
      {
        day: 4,
        title: 'Marine Life & Diving',
        activities: 'Full-day diving/snorkeling Banda Sea, lava flow diving, coral gardens, pelagic encounters.'
      },
      {
        day: 5,
        title: 'Banda to Ternate',
        activities: 'Flight to Ternate, Sultan\'s Palace, clove plantations, Gamalama volcano views.'
      },
      {
        day: 6,
        title: 'Ternate & Tidore',
        activities: 'Tidore Island visit, historic forts, spice markets, traditional villages, boat tours.'
      },
      {
        day: 7,
        title: 'Return & Departure',
        activities: 'Morning leisure, spice shopping, transfer to Ternate Airport.'
      }
    ],
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Maluku%20Spice%20Islands%20Tour.'
  },
  {
    id: 'flores-komodo-traditional',
    title: 'Flores: Komodo & Traditional Villages',
    subtitle: 'Komodo Dragons • Villages • Natural Beauty • Culture',
    destination: 'Labuan Bajo • Komodo • Wae Rebo • Kelimutu',
    duration: '6 Days / 5 Nights',
    dates: 'Year-Round Departures',
    image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_7012c185-728e-48dd-a634-a866967c4d91/artifacts/r76cxbe5_IMG_20180207_161831_217.webp',
    category: 'indonesia',
    geographicGroup: 'bali-nusa-tenggara',
    administrativeRegion: 'East Nusa Tenggara',
    cityOrArea: 'Flores',
    highlights: [
      'Komodo National Park & Dragons',
      'Kelimutu Tri-Colored Lakes',
      'Wae Rebo Traditional Village',
      'Pink Beach Snorkeling',
      'Traditional Manggarai Culture',
      'Scenic Highland Landscapes'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Labuan Bajo',
        activities: 'Airport transfer, hotel check-in, harbor sunset, local seafood dinner.'
      },
      {
        day: 2,
        title: 'Komodo National Park',
        activities: 'Ranger-guided Komodo dragon tracking, Pink Beach snorkeling, Padar Island viewpoint trek.'
      },
      {
        day: 3,
        title: 'Labuan Bajo to Ruteng',
        activities: 'Scenic highland drive, spider rice fields, traditional villages, Ruteng town exploration.'
      },
      {
        day: 4,
        title: 'Wae Rebo Traditional Village',
        activities: 'Trek to Wae Rebo village, experience traditional Mbaru Niang houses, cultural ceremonies, village homestay.'
      },
      {
        day: 5,
        title: 'Kelimutu Lakes',
        activities: 'Sunrise at Kelimutu tri-colored crater lakes, traditional weaving village, Moni town relaxation.'
      },
      {
        day: 6,
        title: 'Departure',
        activities: 'Morning leisure, transfer to Ende or Labuan Bajo airport.'
      }
    ],
    whatsappUrl: 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20the%20Flores%20Komodo%20Tour.'
  },
  {
    id: 'lombok-escape',
    title: 'Lombok: Island Escape & Sasak Heritage',
    subtitle: 'Beaches • Highlands • Culture • Island Life',
    destination: 'Lombok • Kuta • Tetebatu • Senaru',
    duration: '5 Days / 4 Nights',
    dates: 'Year-Round Departures',
  image: '/LombokWaterfall.jpg',
  category: 'indonesia',
  geographicGroup: 'bali-nusa-tenggara',
  administrativeRegion: 'West Nusa Tenggara',
  cityOrArea: 'Lombok',
  highlights: [
    'Senggigi & Kuta Lombok Beaches',
    'Sasak Traditional Villages',
    'Tetebatu Rice Terraces',
    'Sendang Gile & Tiu Kelep Waterfalls',
    'Traditional Sasak Cuisine',
    'Private Island & Nature Experiences'
  ],
  itinerary: [
    {
      day: 1,
      title: 'Arrival & South Lombok',
      activities: 'Airport arrival, private transfer, Kuta Lombok exploration and sunset by the coast.'
    },
    {
      day: 2,
      title: 'Sasak Heritage & Beaches',
      activities: 'Traditional Sasak village, local weaving, Tanjung Aan Beach and traditional lunch.'
    },
    {
      day: 3,
      title: 'Tetebatu Highlands',
    geographicGroup: 'bali-nusa-tenggara',
    administrativeRegion: 'West Nusa Tenggara',
    cityOrArea: 'Sumbawa',
      activities: 'Rice terraces, village walk, local farming experience and traditional Sasak cuisine.'
    },
    {
      day: 4,
      title: 'Waterfalls & Northern Lombok',
      activities: 'Sendang Gile and Tiu Kelep waterfalls, scenic mountain landscapes and village life.'
    },
    {
      day: 5,
      title: 'Departure',
      activities: 'Morning leisure and transfer to Lombok International Airport.'
    }
  ],
  whatsappUrl: 'https://wa.me/62815171187997?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20Lombok%20journey.'
},
{
  id: 'sumbawa-wild-island',
  title: 'Sumbawa: Wild Islands & Coastal Escape',
  subtitle: 'Beaches • Waterfalls • Villages • Island Life',
  destination: 'Sumbawa • Bima • Sumbawa Besar • West Sumbawa',
  duration: '6 Days / 5 Nights',
  dates: 'Year-Round Departures',
  image: '/PulauMoyo.jpg',
  category: 'indonesia',
  highlights: [
    'Moyo Island & Hidden Beaches',
    'Traditional Sumbawa Villages',
    'Mata Jitu Waterfall',
    'Pink Beach & Coastal Landscapes',
    'Local Sumbawa Culture',
    'Private Island Experiences'
  ],
  itinerary: [
    {
      day: 1,
      title: 'Arrival in Sumbawa',
      activities: 'Arrival, private transfer, coastal exploration and sunset experience.'
    },
    {
      day: 2,
      title: 'Moyo Island',
      activities: 'Boat journey to Moyo Island, snorkeling, secluded beaches and island exploration.'
    },
    {
      day: 3,
      title: 'Mata Jitu Waterfall',
      activities: 'Nature excursion to Mata Jitu Waterfall and exploration of Moyo Island landscapes.'
    },
    {
      day: 4,
      title: 'Sumbawa Heritage',
      activities: 'Traditional village visit, local culture, crafts and authentic Sumbawa cuisine.'
    },
    {
      day: 5,
      title: 'Coastal Escape',
      activities: 'Hidden beaches, swimming, snorkeling and relaxed coastal experiences.'
    },
    {
      day: 6,
      title: 'Departure',
      activities: 'Morning leisure and transfer to the airport or onward destination.'
    }
  ],
  whatsappUrl: 'https://wa.me/62815171187997?text=Hello%20Indotravelista,%20I%20want%20to%20inquire%20about%20Sumbawa%20journey.'
},
];

export const allTours = [...worldwideTours, ...indonesiaTours];
